import {
    EVerticalProgressBarAccessibilityStatus as EBarAccessibilityStatus,
    EVerticalProgressBarInteractivityStatus as EBarInteractivityStatus,
    EVerticalProgressBarStarVisibilityStatus as EBarStarVisibility,
    EVerticalProgressBarVariant as EBarVariant
} from "../progress-bars/vertical-progress-bar/vertical-progress-bar.types"

import { EModuleExcerptVariant as EVariant } from "./module-excerpt.types"

const barVariantsMap: { [V in EVariant]: EBarVariant } = {
    [EVariant.Full]: EBarVariant.FullBar,
    [EVariant.Cropped]: EBarVariant.CroppedBar
}

const barStarVisibilitiesMap: { [V in EVariant]: ({ isMobile }: { isMobile: boolean }) => EBarStarVisibility } = {
    [EVariant.Full]: ({ isMobile }: { isMobile: boolean }): EBarStarVisibility =>
        isMobile ? EBarStarVisibility.Hidden : EBarStarVisibility.Visible,
    [EVariant.Cropped]: ({ isMobile: _isMobile }: { isMobile: boolean }): EBarStarVisibility =>
        EBarStarVisibility.Hidden
}

const barInteractivityMap: { [V in EVariant]: ({ isAllowed }: { isAllowed: boolean }) => EBarInteractivityStatus } = {
    [EVariant.Full]: ({ isAllowed }: { isAllowed: boolean }): EBarInteractivityStatus =>
        isAllowed ? EBarInteractivityStatus.Active : EBarInteractivityStatus.Idle,
    [EVariant.Cropped]: ({ isAllowed: _isAllowed }: { isAllowed: boolean }): EBarInteractivityStatus =>
        EBarInteractivityStatus.Idle
}

const barAccessibilityMap: { [V in EVariant]: ({ isAllowed }: { isAllowed: boolean }) => EBarAccessibilityStatus } = {
    [EVariant.Full]: ({ isAllowed }: { isAllowed: boolean }): EBarAccessibilityStatus =>
        isAllowed ? EBarAccessibilityStatus.Accessible : EBarAccessibilityStatus.NotAccessible,
    [EVariant.Cropped]: ({ isAllowed: _isAllowed }: { isAllowed: boolean }): EBarAccessibilityStatus =>
        EBarAccessibilityStatus.NotAccessible
}

const config = { barVariantsMap, barStarVisibilitiesMap, barInteractivityMap, barAccessibilityMap }

export { config as moduleExcerptConfig }
